import { ForgotPassAction } from '../auth/pages/forgot-password/forgot-password.props';
import { chatInitialStateProps } from '../modules/end-user/chat/pages/chat-screen/chat-screen.props';
import {
  PlayModalCardActionState,
  PlayModelCardState,
} from '../modules/end-user/playground/components/ai-cards/play-model-cards';
import {
  PromptSectionActionState,
  PromptSectionState,
} from '../modules/end-user/playground/components/prompt-section';
import { NestedRecord } from './context';
import { budgetStateProps, forgotPassProps, momInitialStateProps } from './interface-types';
import { ChatScreenActionTypes } from './reducer-types';

export const ChatScreenReducer = (
  state: chatInitialStateProps,
  action: ChatScreenActionTypes,
): chatInitialStateProps => {
  switch (action.type) {
    case 'SET_QUERY_INDEX':
      return { ...state, queryIndex: action?.payload };
    case 'SET_RESPONSE_INDEX':
      return { ...state, responseIndex: action?.payload };
    case 'SET_SHOW_QUERY_ACTIONS':
      return { ...state, showQueryActions: action?.payload };
    case 'SET_SHOW_RESPONSE_ACTIONS':
      return { ...state, showResponseActions: action?.payload };
    case 'SET_SHOW_EDIT_QUERY_ACTIONS':
      return { ...state, showEditQueryActions: action?.payload };
    case 'SET_QUERY_VALUE':
      return { ...state, queryValue: action?.payload };
    case 'SET_ROWS':
      return { ...state, rows: action?.payload };
    case 'SET_INPUT_ROWS':
      return { ...state, inputRows: action?.payload };
    case 'SET_UPDATE_QUERY':
      return { ...state, updateQuery: action?.payload };
    case 'SET_ARROW':
      return { ...state, arrow: action?.payload };
    case 'SET_IS_COPIED':
      return { ...state, isCopied: action?.payload };
    case 'SET_RES_COPIED_INDEX':
      return { ...state, resCopiedIndex: action?.payload };
    case 'SET_NEW_RESPONSE_LOADER':
      return { ...state, newResponseLoader: action?.payload };
    case 'SET_CHAT_HISTORY':
      return { ...state, chatHistory: action?.payload };
    case 'SET_SHOW_ANSWER':
      return { ...state, showAnswer: action?.payload };
    case 'SET_QUES_INDEX':
      return { ...state, quesIndex: action?.payload };
    case 'SET_TOKEN':
      return { ...state, token: action?.payload };
    case 'SET_USE_DOCUMENT_ONLY':
      return { ...state, useDocumentOnly: action?.payload };
    case 'SET_CHAT_HAS_DOCUMENT':
      return { ...state, chatHasDocument: action?.payload };
    case 'SET_CHAT_HISTORY_OPEN':
      return { ...state, chatHistoryOpen: action?.payload };
    case 'SET_EDITED_SESSION':
      return { ...state, editedSession: action.payload };
    case 'SET_ACTIVE_SESSION':
      return { ...state, activeSession: action.payload };
    case 'SET_EDIT_SESSION_INDEX':
      return { ...state, editSessionIndex: action.payload };
    case 'TOGGLE_DATA_CHANGED':
      return { ...state, dataChanged: !state.dataChanged };
    case 'SET_TOTAL_SESSIONS':
      return { ...state, totalSessions: action.payload };
    case 'SET_PINNED_LOADING':
      return { ...state, pinnedLoading: action.payload };
    case 'SET_SESSIONS_LOADING':
      return { ...state, sessionsLoading: action.payload };
    case 'SET_TODAY_SESSIONS':
      return { ...state, todaySessions: action.payload };
    case 'SET_LAST7DAYS_SESSIONS':
      return { ...state, last7DaysSessions: action.payload };
    case 'SET_PINNED_SESSIONS':
      return { ...state, pinnedSessions: action.payload };
    case 'SET_SESSION_HISTORY':
      return { ...state, sessionHistory: action.payload };
    case 'SET_PIN_SESSION_HISTORY':
      return { ...state, pinSessionHistory: action.payload };
    case 'SET_CHAT_SCREEN_LOADING':
      return { ...state, chatScreenLoading: action.payload };
    case 'SET_WEB_SEARCH_ENABLED':
      return {
        ...state,
        webSearchEnabled: action.payload,
        webSearchMode: action.payload ? 'on' : 'auto',
      };
    case 'SET_WEB_SEARCH_MODE':
      return {
        ...state,
        webSearchMode: action.payload,
        webSearchEnabled: action.payload === 'on',
      };
    case 'SET_CODE_INTERPRETER_ENABLED':
      return { ...state, codeInterpreterEnabled: action.payload };
    case 'SET_PENDING_FILE':
      return { ...state, pendingFile: action.payload };
    case 'SET_FILE_UPLOAD_PENDING':
      return { ...state, isFileUploadPending: action.payload };
    case 'SET_THINKING_ENABLED':
      return { ...state, thinkingEnabled: action.payload };
    default:
      return state;
  }
};

export const MOMReducer = (
  state: momInitialStateProps,
  action: { payload: NestedRecord; type: string },
) => {
  switch (action.type) {
    case 'SET_QUERY_INDEX':
      return { ...state, queryIndex: action?.payload };
    case 'SET_RESPONSE_INDEX':
      return { ...state, responseIndex: action?.payload };
    case 'SET_SHOW_QUERY_ACTIONS':
      return { ...state, showQueryActions: action?.payload };
    case 'SET_SHOW_RESPONSE_ACTIONS':
      return { ...state, showResponseActions: action?.payload };
    case 'SET_SHOW_EDIT_QUERY_ACTIONS':
      return { ...state, showEditQueryActions: action?.payload };
    case 'SET_QUERY_VALUE':
      return { ...state, queryValue: action?.payload };
    case 'SET_ROWS':
      return { ...state, rows: action?.payload };
    case 'SET_INPUT_ROWS':
      return { ...state, inputRows: action?.payload };
    case 'SET_UPDATE_QUERY':
      return { ...state, updateQuery: action?.payload };
    case 'SET_ARROW':
      return { ...state, arrow: action?.payload };
    case 'SET_IS_COPIED':
      return { ...state, isCopied: action?.payload };
    case 'SET_RES_COPIED_INDEX':
      return { ...state, resCopiedIndex: action?.payload };
    case 'SET_NEW_RESPONSE_LOADER':
      return { ...state, newResponseLoader: action?.payload };
    case 'SET_MOM_HISTORY':
      return { ...state, momHistory: action?.payload };
    case 'SET_SHOW_ANSWER':
      return { ...state, showAnswer: action?.payload };
    case 'SET_QUES_INDEX':
      return { ...state, quesIndex: action?.payload };
    case 'SET_TOKEN':
      return { ...state, token: action?.payload };
    default:
      return state;
  }
};

export const BudgetReducer = (
  state: budgetStateProps,
  action: { payload: NestedRecord; type: string },
) => {
  switch (action.type) {
    case 'SET_BUDGET_MODAL_OPEN':
      return { ...state, budgetModalOpen: action?.payload };

    default:
      return state;
  }
};

export const ForgotPassReducer = (
  state: forgotPassProps,
  action: ForgotPassAction,
): forgotPassProps => {
  switch (action.type) {
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    case 'SET_USERDATA':
      return { ...state, userdata: { ...state.userdata, ...action.payload } };
    case 'SET_ERROR_INFO':
      return { ...state, errorInfo: { ...state.errorInfo, ...action.payload } };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_CAPTCHA_TOKEN':
      return {
        ...state,
        captchaToken: action.payload,
        isCaptchaCompleted: !!action.payload,
      };
    case 'RESET_FORM':
      return { ...state, userdata: { email: '' }, loading: false };
    default:
      return state;
  }
};

export const PromptSectionReducer = (
  state: PromptSectionState,
  action: PromptSectionActionState,
) => {
  switch (action.type) {
    case 'TOGGLE_PROMPT_VISIBILITY':
      return { ...state, isSystemPromptVisible: !state.isSystemPromptVisible };
    case 'OPEN_PROMPT_HISTORY_MODAL':
      return { ...state, openPromptHistory: action.payload };
    case 'CLOSE_PROMPT_HISTORY_MODAL':
      return { ...state, openPromptHistory: false };
    case 'SET_UPLOADED_FILE_NAME':
      return { ...state, setUploadedFileName: action.payload };
    case 'SET_PENDING_FILE':
      return { ...state, pendingFile: action.payload };
    default:
      return state;
  }
};

export const PlayModelCardreducer = (
  state: PlayModelCardState,
  action: PlayModalCardActionState,
) => {
  switch (action.type) {
    case 'SET_PROVIDER_NAME':
      return { ...state, providerName: action.payload };
    case 'SET_MODEL_NAME':
      return { ...state, modelName: action.payload };
    case 'SET_SELECTED_IMAGE':
      return { ...state, selectedImage: action.payload };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};
